import React from 'react';

import PageHeader from 'components/common/PageHeader';
import { ExternalLink } from 'components/common';

import EmbeddedOnePasswordApp from './EmbeddedOnePasswordApp';

const OnePasswordApp = () => (
  <>
    <PageHeader title="1Password Input">
      <span>This feature retrieves Audit Events, Sign-In Attempts and Item Usages from 1Password Platform.</span>
      <p>
        A <ExternalLink href="https://start.1password.com/sign-up?l=en">1Password</ExternalLink> subscription is
        required.
      </p>
    </PageHeader>
    <EmbeddedOnePasswordApp />
  </>
);

export default OnePasswordApp;
